import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles({
    loadingOverlay: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        background: '#000000ba',
        zIndex: 99999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

/** A loading overlay that can be placed on top of any view. */
export default function LoadingOverlay(props) {
    const classes = useStyles();

    if (!props.loading) {
        return null;
    }

    return (
        <div className={clsx(classes.loadingOverlay, props.className)}>
            <CircularProgress size={80} thickness={5} />
        </div>
    );
}
